module.exports = __webpack_public_path__ + "static/media/Homepage4.cc03b44b.jpg";